// SaltyDog – global.js
// Minimal client-side enhancements. Heavier JS gets split per-template.

(function () {
  'use strict';

  // Cart badge live-update via fetch
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = data.item_count;
      });
    } catch (e) { /* noop */ }
  }
  document.addEventListener('DOMContentLoaded', refreshCart);

  // Smooth-scroll for in-page anchors
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // Mobile drawer
  const drawer = document.querySelector('[data-drawer]');
  const burger = document.querySelector('[data-drawer-open]');
  if (drawer && burger) {
    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
    };
    burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(el =>
      el.addEventListener('click', closeDrawer)
    );
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    // Close when a real navigation link is followed
    drawer.querySelectorAll('a[href]').forEach(a => {
      a.addEventListener('click', () => {
        if (!a.getAttribute('href').startsWith('#')) closeDrawer();
      });
    });
  }
})();
